import axios, { AxiosError } from "axios"
import { requestInterceptorSuccessCredentials, requestInterceptorErrorSecurityCredentials, responseInterceptorSuccessCredentials, responseInterceptorErrorCredentials } from "interceptors"
import { CONDITION_PATH, LIST_PATH } from "lib/constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getConditionsService = async () => {
  try {
    const result = await instance.get(CONDITION_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
